import { CARD_HEIGHT, CARD_WIDTH, Game } from '@phaser/scenes/Game';
import { CardObject } from '@phaser/objects/Card.object';
import { clamp } from '@phaser/helpers/Math';

export class ShieldbarBehavior {
  public shieldbar: Phaser.GameObjects.Rectangle;

  public set shield(value: number) {
    const parsedValue = value < 0 ? 0 : value;
    this.shieldbar.width = clamp(CARD_WIDTH * (parsedValue / this._maxValue), 0, CARD_WIDTH);
  }

  public set max(value: number) {
    this._maxValue = value < 0 ? 0 : value;
  }

  private _scene: Game = Game.current;
  private _maxValue: number = 100;

  constructor(private _card: CardObject) {
    this._maxValue = this._card.data.core.shield;
    this._setShieldbar();
    this.shield = this._maxValue;
  }

  private _setShieldbar() {
    this.shieldbar = this._scene.add.rectangle(0, CARD_HEIGHT / 2 - 7.5, CARD_WIDTH, 5, 0x00DDFF);
    this._card.container.add([this.shieldbar]);
  }
}